"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapMarketingParameters = void 0;
var types_1 = require("../types");
var getMarketingChannel_1 = require("./getMarketingChannel");
var utmKeys = [
    'utm_content',
    'utm_medium',
    'utm_campaign',
    'utm_source',
    'utm_term',
];
var trackingParams = [
    { source: 'google', param: 'gclid' },
    { source: 'facebook', param: 'fbclid' },
    { source: 'tiktok', param: 'ttclid' },
    { source: 'bing', param: 'msclkid' },
    { source: 'tradedoubler', param: 'tduid' },
];
var mapMarketingParameters = function (url, referrer) {
    var _a, _b, _c, _d, _e;
    var urlParams = new URLSearchParams((_a = url.split('?')[1]) !== null && _a !== void 0 ? _a : '');
    var utmParams = utmKeys.reduce(function (obj, key) {
        var _a;
        return (__assign(__assign({}, obj), (_a = {}, _a[key] = urlParams.get(key), _a)));
    }, {});
    // Handle user coming from ad campaign
    if (utmKeys.some(function (p) { return utmParams[p] !== null; })) {
        var medium = utmParams.utm_medium;
        var marketingMedium = (0, getMarketingChannel_1.isAffiliateMedium)(medium)
            ? types_1.MarketingMedium.Affiliates
            : medium || '_';
        var traits_1 = {
            marketing_content: (_b = utmParams.utm_content) !== null && _b !== void 0 ? _b : '_',
            marketing_medium: marketingMedium,
            marketing_name: (_c = utmParams.utm_campaign) !== null && _c !== void 0 ? _c : '_',
            marketing_source: (_d = utmParams.utm_source) !== null && _d !== void 0 ? _d : '_',
            marketing_term: (_e = utmParams.utm_term) !== null && _e !== void 0 ? _e : '_',
        };
        trackingParams.forEach(function (p) {
            if (p.source === utmParams.utm_source) {
                var value = urlParams.get(p.param);
                if (value !== null) {
                    traits_1[p.param] = value;
                }
            }
        });
        traits_1.marketing_channel = (0, getMarketingChannel_1.getMarketingChannel)(traits_1.marketing_source, traits_1.marketing_medium);
        return traits_1;
    }
    // Handle user coming from referrer
    if (referrer.includes('grover.com'))
        return null;
    var traits = {
        marketing_content: '_',
        marketing_term: '_',
        marketing_name: '_',
        marketing_source: '_',
        marketing_medium: '_',
    };
    if (referrer.includes('srvtrck.com')) {
        traits.marketing_source = 'daisycon';
        traits.marketing_medium = 'affiliates';
    }
    else if (referrer.includes('tradedoubler.com')) {
        traits.marketing_source = 'tradedoubler';
        traits.marketing_medium = 'affiliates';
    }
    else if (referrer.length > 0 &&
        !referrer.includes('paypal') &&
        !referrer.includes('secure-magenta1.be2bill.com') &&
        !url.includes('/join')) {
        traits.marketing_source = referrer;
        traits.marketing_medium = 'organic';
    }
    else if (url.includes('/join') || url.includes('/referred/')) {
        traits.marketing_source = 'grover';
        traits.marketing_medium = 'refer_friend';
    }
    else {
        traits.marketing_source = 'direct';
        traits.marketing_medium = '_';
    }
    return __assign(__assign({}, traits), { marketing_channel: (0, getMarketingChannel_1.getMarketingChannel)(traits.marketing_source, traits.marketing_medium) });
};
exports.mapMarketingParameters = mapMarketingParameters;
//# sourceMappingURL=mapMarketingParameters.js.map